export const environment = {
  production: true,
  apiURL: 'https://api.multipedidos.com.br',
  imgURL: 'https://images.multipedidos.com.br',
  // Versões WebP no tamanho em que aparecem (stack aws-sam-imagens). Vazio = o JPEG
  // original de `imgURL`, como antes. Ver src/app/shared/utils/versao-de-imagem.ts.
  imgVariantURL: 'https://imagens.multipedidos.com.br',
  orderCacheURL: 'https://product-suggestion.lambda.multipedidos.com.br',
  onesignalAppID: "81ee0c26-fc4e-4d22-90f6-5fd176a67fda",
  pusher: {
    key: '715a9e0b34b517fdbc67',
    cluster: 'us3',
    forceTLS: true
  },
  googleMapsKey: 'AIzaSyCaspbeWCXZIbIBNfrP621V_cO6EXVqTd0',
  orderCacheURLTracking: 'https://track.lambda.multipedidos.com.br',
  // Instância self-hosted do OpenPanel (funil de conversão v2).
  openPanel: {
    apiUrl: 'https://events.pedir.delivery',
    clientId: '690f3f9b-22b9-4395-892d-464d8979dc1b',
  },
  // Telemetria do funil do pedido (stack SAM order-flow-monitor, us-east-1).
  // Único ambiente que alimenta o funil. Endpoint = output IngestUrlEndpoint da stack: a
  // Function URL da Lambda de ingest, que não cobra por request (o HttpApi antigo,
  // ehgohntp1d.execute-api…/prod/order-flow-log, segue no ar para os bundles em cache). O
  // caminho fica na URL porque o anti-loop do api-fail.interceptor casa por `order-flow-log`.
  // Vazio = telemetria desligada.
  orderFlowLogURL: 'https://lsbhqbvyf2gmheo236ujmpb3si0xhmsm.lambda-url.us-east-1.on.aws/order-flow-log',
  mpBannerLogURL: 'https://4nq0oxrw83.execute-api.us-east-1.amazonaws.com/prod/mp-banner-log',
  // Telemetria da nova tela de endereços (stack SAM aws-sam-telemetria-nova-tela-enderecos,
  // us-east-1). Endpoint = output `IngestUrlEndpoint` da stack: a Function URL da Lambda de
  // ingest, que não cobra por request (o HttpApi antigo, br5saypn1j.execute-api…/prod/multisignal-log,
  // segue no ar para os bundles em cache). O caminho fica na URL porque o anti-loop do
  // api-fail.interceptor casa por `multisignal-log`. Vazio = desligada.
  multiSignalLogURL: 'https://boxddjajmgjtxntllozulivjze0tulwx.lambda-url.us-east-1.on.aws/multisignal-log',
  // Coluna `source` da tabela do Athena. Explicita de proposito: e o que separa producao de
  // green na MESMA base. Toda consulta de producao tem de filtrar por ela.
  multiSignalSource: 'pedirdelivery-client',
  // Sentry (erros + tracing + session replay). O SDK entra por chunk LAZY e só
  // nos devices que passam por todos os gates de `sentry-config.ts`.
  //
  // As taxas abaixo são dimensionadas para a quota REAL da conta
  // (plano Developer, verificado em 06/08/2026): 5.000 erros/mês, 50 replays/mês
  // e 5M spans/mês — para a ORGANIZAÇÃO inteira, que tem outros 4 projetos.
  // O plano NÃO oferece rate limit por client key (só Business+), então estes
  // números e o throttle do OrderFlowErrorHandler são a única proteção que
  // existe. Estourar não gera fatura (eventos são descartados), gera CEGUEIRA.
  //
  // `clientSamplePct` é a alavanca mestre: 1% de propósito — canário. A escada
  // (1 → 5 → 25 → 100) e a conta de guardanapo por degrau estão em SENTRY.md.
  // Acima de ~5% os 5.000 erros/mês não fecham sem subir de plano.
  sentry: {
    dsn: 'https://7fcf9b05d3b8abe063fb2a5404a231f4@o1392158.ingest.us.sentry.io/4508269894238208',
    environment: 'production',
    clientSamplePct: 1,               // % de DEVICES que carregam o SDK
    tracesSampleRate: 0.05,           // dentro da coorte acima
    replaysSessionSampleRate: 0,      // nunca grava sessão saudável
    // 2% das sessões COM erro: o teto de 50 replays/mês é o recurso mais
    // escasso do plano (1,6 por dia). Em 10% a quota queimava na 1ª semana.
    replaysOnErrorSampleRate: 0.02,
  },
  // Página de design system (/design-system): ferramenta local de desenvolvimento,
  // nunca publicada fora do `ionic serve`.
  designSystemPage: false,
};
